export function numberWithCommas(x: any) {
  if (x === undefined || x === '') return x
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
